'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClipboardIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var ClipboardIcon = function ClipboardIcon(_ref) {
  var color = _ref.color,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === undefined ? 'transparent' : _ref$fillColor,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ['color', 'fillColor', 'height', 'width']);

  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 24 24',
    width: width,
    height: height
  }, props), _react2.default.createElement('path', {
    d: 'M5.75,2 C5.75,1.86192881 5.86192881,1.75 6,1.75 L12,1.75 C12.1380712,1.75 12.25,1.86192881 12.25,2 L12.25,4 C12.25,4.13807119 12.1380712,4.25 12,4.25 L6,4.25 C5.86192881,4.25 5.75,4.13807119 5.75,4 L5.75,2 Z',
    fill: fillColor,
    transform: 'translate(3, 1)'
  }), _react2.default.createElement('path', {
    d: 'M16.25,19 C16.25,19.6903559 15.6903559,20.25 15,20.25 L3,20.25 C2.30964406,20.25 1.75,19.6903559 1.75,19 L1.75,5 C1.75,4.30964406 2.30964406,3.75 3,3.75 L4.25,3.75 L4.25,4 C4.25546317,4.96422633 5.03577367,5.74453683 6,5.75 L12,5.75 C12.9642263,5.74453683 13.7445368,4.96422633 13.75,4 L13.75,3.75 L15,3.75 C15.6903559,3.75 16.25,4.30964406 16.25,5 L16.25,19 Z',
    fill: fillColor,
    transform: 'translate(3, 1)'
  }), _react2.default.createElement('path', {
    d: 'M18 3.25h-1.25V3A1.76 1.76 0 0 0 15 1.25H9A1.76 1.76 0 0 0 7.25 3v.25H6A2.75 2.75 0 0 0 3.25 6v14A2.75 2.75 0 0 0 6 22.75h12A2.75 2.75 0 0 0 20.75 20V6A2.75 2.75 0 0 0 18 3.25zM8.75 3A.25.25 0 0 1 9 2.75h6a.25.25 0 0 1 .25.25v2a.25.25 0 0 1-.25.25H9A.25.25 0 0 1 8.75 5zm10.5 17A1.25 1.25 0 0 1 18 21.25H6A1.25 1.25 0 0 1 4.75 20V6A1.25 1.25 0 0 1 6 4.75h1.25V5A1.76 1.76 0 0 0 9 6.75h6A1.76 1.76 0 0 0 16.75 5v-.25H18A1.25 1.25 0 0 1 19.25 6zm-3.56-7.25H8.31a.75.75 0 0 1 0-1.5h7.38a.75.75 0 0 1 0 1.5zm0 4.33H8.31a.75.75 0 0 1 0-1.5h7.38a.75.75 0 1 1 0 1.5z',
    fill: color
  }));
};

exports.ClipboardIcon = ClipboardIcon;